const professionalGames = [
    {   
        gameBanner: 'geometa', 
        gameName: 'Geometa', 
        releaseYear: 'Maio 2021', 
        releaseState: 'Lançado', 
        company: 'Ludus Studios',
        role: 'Programador Unity',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.Inteceleri.Geometa',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'matematicando', 
        gameName: 'Matematicando', 
        releaseYear: ' Maio 2023', 
        releaseState: 'Lançado', 
        company: 'Ludus Studios',
        role: 'Programador Unity',
        playStoreLink: 'https://play.google.com/store/apps/details?id=air.MatematicandoEducation',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'hydro', 
        gameName: 'Hydro Ambiental', 
        releaseYear: 'Março 2023', 
        releaseState: 'Lançado', 
        company: 'Ludus Studios',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: 'https://www.hydro.com/pt-BR/imprensa/noticias/2023/hydro-une-educacao-ambiental-e-inovacao-em-mina-de-bauxita/',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'trix', 
        gameName: 'Trix Battle Tactics', 
        releaseYear: 'Março 2023', 
        releaseState: 'Cancelado', 
        company: 'Brais Games',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: '',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/trix-battle-tactics',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'alexia', 
        gameName: 'Alexia Trials', 
        releaseYear: 'Outubro 2022', 
        releaseState: 'Lançado', 
        company: 'Brais Games',
        role: 'Programador Unity',
        playStoreLink: '',
        githubLink: '',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/alexia-trials',
        youtubeLink: 'https://www.youtube.com/watch?v=wQxNF6t4T1A',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'hank', 
        gameName: "Hank'n Spank", 
        releaseYear: 'Outubro 2021', 
        releaseState: 'Lançado', 
        company: 'Brais Games',
        role: 'Programador Unity',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.BraisGames.HanknSpank',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'bubbli', 
        gameName: 'Bubbli Bash', 
        releaseYear: 'Setembro 2021', 
        releaseState: 'Lançado', 
        company: 'Brais Games',
        role: 'Programador Unity',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.BraisGames.Bubblibash',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'bit-draw', 
        gameName: 'Bit Draw', 
        releaseYear: 'Julho 2021', 
        releaseState: 'Lançado', 
        company: 'Brais Games',
        role: 'Programador Unity',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.BraisGames.BitDraw',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'renegado', 
        gameName: 'Renegado', 
        releaseYear: 'Março 2021', 
        releaseState: 'Lançado', 
        company: 'Black Paladins',
        role: 'Programador Unity & Game Designer',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.BlackPaladins.Renegado',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
];

export default professionalGames